import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";

const ProjectsContext = createContext();

export default function ProjectsProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();
  const [currentProjects, setProjects] = useState([]);

  const updateProjects = async () => {
    try {
      logger.debug("ProjectsProvider.updateProjects", `GET field/projects`);

      const data = await auth.get("field/projects");

      logger.debug("ProjectsProvider.updateProjects", `Retrieved data`);

      const sortedData = data.sort((a, b) => {
        if (a.projectName > b.projectName) return 1;
        if (a.projectName < b.projectName) return -1;
        return 0;
      });

      setProjects(sortedData);
      return sortedData;
    } catch (error) {
      logger.debug(
        "ProjectsProvider.updateProjects",
        `Failed to retrieve data`
      );
      setProjects([]);
      return [];
    }
  };

  const getProjects = () => currentProjects;

  return (
    <ProjectsContext.Provider
      value={{
        getProjects,
        updateProjects,
      }}
    >
      {children}
    </ProjectsContext.Provider>
  );
}

ProjectsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useProjects = () => useContext(ProjectsContext);
